import Model, { hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class CalendarModel extends Model {
  @hasMany('enquiry', { inverse: 'calendar', async: false })
  enquiries!: ModelRegistry['enquiry'][];

  @hasMany('booking', { inverse: 'calendar', async: false })
  bookings!: ModelRegistry['booking'][];

  @hasMany('booking-request', { inverse: 'calendar', async: false })
  bookingRequests!: ModelRegistry['booking-request'][];

  @hasMany('changeover', { inverse: 'calendar', async: false })
  changeovers!: ModelRegistry['changeover'][];

  @hasMany('rate', { inverse: 'calendar', async: false })
  rates!: ModelRegistry['rate'][];

  @hasMany('unavailability', { inverse: 'calendar', async: false })
  unavailabilities!: ModelRegistry['unavailability'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    calendar: CalendarModel;
  }
}
